export const REGEX_FILENAME = /^#filename=(.*)#/
export const REGEX_NOTE = /^#note=(.*)#/
